import { Card, CardBody, CardText } from 'reactstrap';

const EquipLore = ({ lore }) => {
    return (
        <Card className="gs-card gs-equip-detail__lore">
            <CardBody className="gs-card-body">
                <CardText tag="div">
                    <div className="gs-unit-lore__body">
                        {lore ? (
                            <p>{lore}</p>
                        ) : (
                            <p className="gs-unit-detail__note">Lore is currently unavailable</p>
                        )}
                    </div>
                </CardText>
            </CardBody>
        </Card>
    )
}

export default EquipLore;
